"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const IsNullable_1 = require("../../transformation/IsNullable");
const Project_1 = require("../entity/Project");
class ProjectDTO {
}
exports.ProjectDTO = ProjectDTO;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ProjectDTO.prototype, "projectName", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsUUID)(undefined, { each: true }),
    __metadata("design:type", Array)
], ProjectDTO.prototype, "projectTagIds", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], ProjectDTO.prototype, "clientId", void 0);
__decorate([
    (0, class_validator_1.IsIn)(Project_1.ProjectStatusList),
    __metadata("design:type", String)
], ProjectDTO.prototype, "projectStatus", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    __metadata("design:type", String)
], ProjectDTO.prototype, "projectManagerId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)(),
    (0, IsNullable_1.IsNullable)(),
    __metadata("design:type", String)
], ProjectDTO.prototype, "projectVariationId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsUUID)(undefined, { each: true }),
    __metadata("design:type", Array)
], ProjectDTO.prototype, "supportingProjectManagerIds", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectDTO.prototype, "createdInWordbee", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Type)(() => Boolean),
    __metadata("design:type", Boolean)
], ProjectDTO.prototype, "tmConsolidated", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, IsNullable_1.IsNullable)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], ProjectDTO.prototype, "deadline", void 0);
